import { useState } from 'react';

import { useQuery } from '@apollo/client';
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';

import { MIN_SEARCH_LENGTH, SELECTION_LIMIT } from '@/constants';
import { SEARCH_DONORS, SortEnumType } from '@/types.gql';

interface IDonorMultiSelectProps {
  className?: string;
  label?: string;
  value: string[];
  onChange: (donors: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
  ownerId?: string;
  appendTo?: HTMLElement | null;
  optionLabel?: string;
  optionValue?: string;
}

export const DonorMultiSelect = ({
  className,
  label,
  value,
  onChange,
  disabled = false,
  placeholder = 'Select donors',
  ownerId,
  appendTo,
}: IDonorMultiSelectProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const response = useQuery(SEARCH_DONORS, {
    variables: {
      skip: 0,
      take: SELECTION_LIMIT,
      where: {
        or: [
          { id: { in: value } },
          ...(searchTerm
            ? [
                {
                  ...(ownerId ? { ownerId: { eq: ownerId } } : {}),
                  name: { contains: searchTerm },
                },
              ]
            : []),
        ],
      },
      order: { name: SortEnumType.ASC },
    },
  });

  const formattedDonors = response.data?.donors?.items?.map((donor) => ({
    id: donor.id,
    name: donor.registrationNumber
      ? `${donor.name} (${donor.registrationNumber})`
      : donor.name,
  }));

  const handleFilter = (event: { filter: string }) => {
    if (event.filter.length >= MIN_SEARCH_LENGTH) {
      setSearchTerm(event.filter);
    }
  };

  const handleChange = (e: MultiSelectChangeEvent) => {
    onChange?.(e.value);
  };

  return (
    <div className={`donor-multi-select ${className || ''}`}>
      {label && <label className="mb-2 block">{label}</label>}
      <MultiSelect
        value={value}
        onChange={handleChange}
        options={formattedDonors}
        optionLabel="name"
        optionValue="id"
        filter
        filterPlaceholder="Search donors..."
        onFilter={handleFilter}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
        display="chip"
        appendTo={appendTo}
      />
    </div>
  );
};
